import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { formatDate, formatTime } from "../../utils/Formatters.ts";

interface ParentCardProps {
  id: number;
  name: string;
  location: string;
  dateFrom: string;
  dateTo?: string | null;
  timeFrom: string;
  timeTo: string;
  bookingNum: string;
  agentName: string;
  tourType: string;
}

const ParentCard: React.FC<ParentCardProps> = ({
  name,
  location,
  dateFrom,
  dateTo,
  timeFrom,
  timeTo,
  bookingNum,
  agentName,
}) => (
  <Card style={{ width: "100%", marginBottom: "16px", padding: "12px" }}>
    {/* Header Section */}
    <CardContent style={{ padding: "8px 0" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        sx={{ px: { xs: 2, sm: 4, md: 12, lg: 20 } }} // Responsive horizontal padding
      >
        <Typography variant="h6" fontWeight="bold">
          {name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {`Location: ${location}`}
        </Typography>
      </Box>
    </CardContent>

    {/* Date and Time Section */}
    <CardContent style={{ padding: "8px 0" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        sx={{ px: { xs: 2, sm: 6, md: 15, lg: 30 } }} // Responsive horizontal padding
      >
        {dateFrom === dateTo || !dateTo ? (
          <Typography variant="body2">
            <strong>Date:</strong> {formatDate(dateFrom)}
          </Typography>
        ) : (
          <Typography variant="body2">
            <strong>Date:</strong> {`${formatDate(dateFrom)} to ${formatDate(dateTo)}`}
          </Typography>
        )}
        <Typography variant="body2">
          <strong>Time:</strong> {`${formatTime(timeFrom)} - ${formatTime(timeTo)}`}
        </Typography>
      </Box>
    </CardContent>

    <Divider style={{ margin: "8px 0" }} />

    {/* Additional Info Section */}
    <CardContent style={{ padding: "8px 0" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        sx={{ px: { xs: 2, sm: 6, md: 15, lg: 30 } }} // Responsive horizontal padding
      >
        <Typography variant="body2">
          <strong>Booking #:</strong> {bookingNum}
        </Typography>
        <Typography variant="body2">
          <strong>Agent:</strong> {agentName}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default ParentCard;
